import * as React from 'react';

const AppUpdateSVG = (props)=>{
    return React.createElement("svg", {
        width: "200",
        height: "165",
        viewBox: "0 0 200 165",
        fill: "none",
        ...props
    }, React.createElement("g", {
        clipPath: "url(#clip0_7919_391305)"
    }, React.createElement("g", {
        clipPath: "url(#clip1_7919_391305)"
    }, React.createElement("g", {
        clipPath: "url(#clip2_7919_391305)"
    }, React.createElement("rect", {
        width: "46.2923",
        height: "63.1258",
        transform: "matrix(-1 0 0 1 137.975 102.679)",
        fill: "#99E7D0"
    }), React.createElement("rect", {
        width: "46.2923",
        height: "63.1258",
        transform: "matrix(-1 0 0 1 184.268 102.679)",
        fill: "#66DBB8"
    }), React.createElement("rect", {
        width: "8.41678",
        height: "14.7294",
        rx: "4.20839",
        transform: "matrix(-1 0 0 1 109.646 114.383)",
        stroke: "#33CFA1",
        strokeWidth: "1.503"
    }), React.createElement("rect", {
        width: "8.41678",
        height: "14.7294",
        rx: "4.20839",
        transform: "matrix(-1 0 0 1 125.35 141.661)",
        stroke: "#33CFA1",
        strokeWidth: "1.503"
    }), React.createElement("rect", {
        width: "8.41678",
        height: "14.7294",
        rx: "4.20839",
        transform: "matrix(-1 0 0 1 176.903 129.113)",
        stroke: "#00C389",
        strokeWidth: "1.503"
    }), React.createElement("rect", {
        width: "8.41678",
        height: "14.7294",
        rx: "4.20839",
        transform: "matrix(-1 0 0 1 157.439 110.701)",
        stroke: "#00C389",
        strokeWidth: "1.503"
    }), React.createElement("rect", {
        width: "16.8336",
        height: "36.8234",
        rx: "8.41678",
        transform: "matrix(-1 0 0 1 161.647 141.661)",
        stroke: "#00C389",
        strokeWidth: "1.503"
    }), React.createElement("circle", {
        cx: "75.2153",
        cy: "167.142",
        r: "9.53463",
        fill: "#66DBB8"
    }), React.createElement("circle", {
        cx: "93.1662",
        cy: "165.832",
        r: "12.6525",
        fill: "#66DBB8"
    }))), React.createElement("path", {
        d: "M200.225 79.4665L183.391 102.678L183.391 56.3861L200.225 79.4665Z",
        fill: "#66DBB8"
    }), React.createElement("rect", {
        width: "65.23",
        height: "46.2923",
        transform: "matrix(-1 0 0 1 183.392 56.3864)",
        fill: "#EFEFFF"
    }), React.createElement("rect", {
        opacity: "0.2",
        x: "183.365",
        y: "102.679",
        width: "91.6828",
        height: "106.804",
        transform: "rotate(180 183.365 102.679)",
        fill: "url(#paint0_linear_7919_391305)"
    }), React.createElement("rect", {
        x: "171.599",
        y: "81.6888",
        width: "5.80065",
        height: "5.80065",
        rx: "0.969828",
        transform: "rotate(45 171.599 81.6888)",
        fill: "#EFEFFF"
    }), React.createElement("circle", {
        cx: "159.586",
        cy: "93.3845",
        r: "1.77179",
        fill: "#EFEFFF"
    }), React.createElement("g", {
        clipPath: "url(#clip3_7919_391305)"
    }, React.createElement("rect", {
        x: "53.4521",
        y: "48.3271",
        width: "18.8208",
        height: "18.8208",
        rx: "2.45489",
        transform: "rotate(-29.1017 53.4521 48.3271)",
        fill: "#C1BDFF"
    })), React.createElement("g", {
        clipPath: "url(#clip4_7919_391305)"
    }, React.createElement("path", {
        d: "M141.761 70.1403C142.598 69.8792 143.511 70.0847 144.156 70.6793L151.791 77.7204C152.435 78.315 152.714 79.2084 152.521 80.0641L150.241 90.1966C150.048 91.0522 149.414 91.7401 148.577 92.0012L138.661 95.0926C137.824 95.3536 136.911 95.1481 136.266 94.5536L128.632 87.5124C127.987 86.9178 127.708 86.0244 127.901 85.1688L130.181 75.0363C130.374 74.1806 131.008 73.4927 131.846 73.2317L141.761 70.1403Z",
        fill: "#A19DFF"
    })), React.createElement("g", {
        clipPath: "url(#clip5_7919_391305)"
    }, React.createElement("path", {
        d: "M120.638 62.822L123.88 49.9009C124.065 49.1624 123.23 48.5933 122.61 49.036L108.386 59.2017C107.818 59.6073 107.986 60.4914 108.663 60.6612L119.646 63.4165C120.084 63.5265 120.528 63.2603 120.638 62.822Z",
        fill: "#C1BDFF"
    }), React.createElement("path", {
        d: "M116.672 58.4524L113.431 71.3734C113.245 72.1119 114.081 72.681 114.7 72.2383L128.925 62.0726C129.492 61.6671 129.324 60.7829 128.648 60.6132L117.665 57.8578C117.227 57.7478 116.782 58.014 116.672 58.4524Z",
        fill: "#C1BDFF"
    })), React.createElement("circle", {
        cx: "41.7843",
        cy: "69.4305",
        r: "11.4562",
        fill: "#A19DFF"
    }), React.createElement("path", {
        d: "M102.899 41.5684C106.266 46.0559 105.357 52.4233 100.87 55.7903V55.7903C96.3822 59.1572 90.0149 58.2489 86.6479 53.7613V53.7613C83.2809 49.2738 84.1893 42.9065 88.6768 39.5395L95.3788 34.511C96.1649 33.9212 97.2803 34.0803 97.8702 34.8665L102.899 41.5684Z",
        fill: "#A19DFF"
    }), React.createElement("g", {
        clipPath: "url(#clip6_7919_391305)"
    }, React.createElement("path", {
        d: "M22.9959 85.1229C23.388 84.0869 24.6744 83.7315 25.5428 84.4193L29.9848 87.9376C30.2531 88.1501 30.5812 88.2731 30.9231 88.2894L36.5833 88.5591C37.6897 88.6119 38.4253 89.7255 38.0395 90.7639L36.066 96.0757C35.9468 96.3965 35.9312 96.7466 36.0214 97.0768L37.5139 102.543C37.8057 103.612 36.9739 104.656 35.8671 104.61L30.2054 104.374C29.8635 104.36 29.5257 104.453 29.2396 104.641L24.5018 107.75C23.5757 108.357 22.326 107.889 22.0278 106.822L20.5021 101.365C20.41 101.035 20.2168 100.743 19.9499 100.529L15.5292 96.9834C14.6651 96.2904 14.7246 94.9571 15.647 94.3438L20.3658 91.2064C20.6508 91.0169 20.8692 90.7428 20.9903 90.4228L22.9959 85.1229Z",
        fill: "#D0CEFF"
    })), React.createElement("g", {
        clipPath: "url(#clip7_7919_391305)"
    }, React.createElement("path", {
        d: "M39.2998 148.055L39.2998 166.168",
        stroke: "#33CFA1",
        strokeWidth: "1.503",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), React.createElement("path", {
        d: "M12.9326 154.061L12.9326 166.168",
        stroke: "#66DBB8",
        strokeWidth: "1.503",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), React.createElement("circle", {
        cx: "12.9327",
        cy: "141.128",
        r: "12.9327",
        fill: "#66DBB8"
    }), React.createElement("circle", {
        cx: "39.3006",
        cy: "131.395",
        r: "19.7615",
        fill: "#33CFA1"
    }), React.createElement("circle", {
        cx: "52.3163",
        cy: "124.06",
        r: "1.67273",
        fill: "#D0CEFF"
    }), React.createElement("circle", {
        cx: "29.5223",
        cy: "131.394",
        r: "1.67273",
        fill: "#D0CEFF"
    }), React.createElement("circle", {
        cx: "6.03796",
        cy: "136.986",
        r: "1.67273",
        fill: "#E0DEFF"
    }), React.createElement("circle", {
        cx: "41.0927",
        cy: "117.013",
        r: "1.67273",
        fill: "#D0CEFF"
    }), React.createElement("circle", {
        cx: "39.4198",
        cy: "124.952",
        r: "1.67273",
        fill: "#D0CEFF"
    }), React.createElement("circle", {
        cx: "16.2782",
        cy: "139.625",
        r: "1.67273",
        fill: "#E0DEFF"
    }), React.createElement("circle", {
        cx: "27.4003",
        cy: "123.28",
        r: "1.67273",
        fill: "#D0CEFF"
    }), React.createElement("circle", {
        cx: "45.6464",
        cy: "136.418",
        r: "1.67273",
        fill: "#D0CEFF"
    }), React.createElement("circle", {
        cx: "32.868",
        cy: "119.383",
        r: "1.67273",
        fill: "#D0CEFF"
    }), React.createElement("circle", {
        cx: "12.1805",
        cy: "133.072",
        r: "1.67273",
        fill: "#E0DEFF"
    })), React.createElement("rect", {
        x: "132.62",
        y: "13.57",
        width: "5.52363",
        height: "5.52363",
        rx: "0.969828",
        transform: "rotate(45 132.62 13.57)",
        fill: "white"
    }), React.createElement("rect", {
        x: "125.604",
        y: "28.3895",
        width: "3.57329",
        height: "3.57329",
        rx: "0.969828",
        transform: "rotate(45 125.604 28.3895)",
        fill: "white"
    }), React.createElement("rect", {
        x: "114.638",
        y: "16.117",
        width: "8.63666",
        height: "8.63666",
        rx: "1.93966",
        transform: "rotate(45 114.638 16.117)",
        fill: "white"
    }), React.createElement("circle", {
        cx: "104.975",
        cy: "14.5971",
        r: "2.19615",
        fill: "white"
    })), React.createElement("defs", null, React.createElement("linearGradient", {
        id: "paint0_linear_7919_391305",
        x1: "229.207",
        y1: "102.679",
        x2: "229.207",
        y2: "209.483",
        gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
        stopColor: "#635BFF"
    }), React.createElement("stop", {
        offset: "1",
        stopColor: "#635BFF",
        stopOpacity: "0"
    })), React.createElement("clipPath", {
        id: "clip0_7919_391305"
    }, React.createElement("rect", {
        width: "200",
        height: "165",
        fill: "white"
    })), React.createElement("clipPath", {
        id: "clip1_7919_391305"
    }, React.createElement("rect", {
        width: "117.835",
        height: "79.9594",
        fill: "white",
        transform: "translate(65.5312 85.8451)"
    })), React.createElement("clipPath", {
        id: "clip2_7919_391305"
    }, React.createElement("rect", {
        width: "118.737",
        height: "79.6588",
        fill: "white",
        transform: "translate(65.6816 86.0543)"
    })), React.createElement("clipPath", {
        id: "clip3_7919_391305"
    }, React.createElement("rect", {
        width: "29.4587",
        height: "29.4587",
        fill: "white",
        transform: "translate(56.1201 33.7719) rotate(15.8983)"
    })), React.createElement("clipPath", {
        id: "clip4_7919_391305"
    }, React.createElement("rect", {
        width: "29.4587",
        height: "29.4587",
        fill: "white",
        transform: "translate(129.075 65.0125) rotate(12.6835)"
    })), React.createElement("clipPath", {
        id: "clip5_7919_391305"
    }, React.createElement("rect", {
        width: "29.4587",
        height: "29.4587",
        fill: "white",
        transform: "translate(107.953 42.7664) rotate(14.0835)"
    })), React.createElement("clipPath", {
        id: "clip6_7919_391305"
    }, React.createElement("rect", {
        width: "29.4587",
        height: "29.4587",
        fill: "white",
        transform: "translate(9.01855 84.8818) rotate(-15.4453)"
    })), React.createElement("clipPath", {
        id: "clip7_7919_391305"
    }, React.createElement("rect", {
        width: "60.1198",
        height: "54.1078",
        fill: "white",
        transform: "translate(0 111.605)"
    }))));
};

export { AppUpdateSVG };
